import * as React from 'react';
import {IocStore} from "../stores/ioc";
import {observer} from "mobx-react-lite";
import {Redirect, useParams} from "react-router-dom";
import {refangIoc} from "../utils/ioc";

const CheckIocPage = observer(function CheckIocPage(props: { store: IocStore }) {
    const params: { ioc: string } = useParams()

    props.store.ioc = refangIoc(params.ioc)

    return <Redirect to={{
        pathname: "/auth",
        state: {check: 'ioc'}
    }} />
})

export default CheckIocPage